{
  "inputs": {
    "autopay": {
      "isRequired": true,
      "validity": []
    }
  }
}
